export const useGetParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    title: getDefaultValue(
      searchParams.get('title'),
      'На какого персонажа\\n ты похож?',
    ),
  };
};
